import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router'; declare var $: any;
import { Observable, Subject } from 'rxjs';
import { AnnuityItemsViewModel } from '../../../models/annuity-view.model';
import { DickerSelectListItem, CSPPerpetual_AzureRISubscriptionViewModel, CSPPerpetualItemsViewModel, CspAzureRilist, GetProductPricingV2, CSPSubscriptions } from '../../../models/csp.model';
import { CommonService } from '../../../services';
import { ManageService } from '../../../services/manage.service';
import { CspAzureLocationModel } from '../../../models/subscription-details-view.model';
import { ApiResponse, MnpIdAipiResponse } from '../../../models/api-response.model';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmMnpidComponent } from '../../../popup-collection/confirm-mnpid/confirm-mnpid.component';
import { FormControl } from '@angular/forms';
import { debounceTime, switchMap, tap, map, catchError, take, takeUntil, finalize } from 'rxjs/operators';

import { combineLatest, of } from 'rxjs';
import { DialogService } from '../../../services/dialog.service';
import { CSPConditionCheckComponent } from '../../../popup-collection/csp-condition-check/csp-condition-check.component';
import { DDCustomer } from '../../../models/customer.model';
import { CustomerService } from '../../../services/customer.service';
import { CurrentUserModel } from '../../../models/account-ledger.model';
import { AuthService } from '../../../services/auth.service';

interface AzureRiDuration {
  id: number,
  year: number
}

@Component({
  selector: 'app-add-products',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.css']
})

export class AddProductsComponent implements OnInit, OnDestroy {
  @ViewChild("ParentWrapper", { static: true }) parentWrapper: ElementRef;

  title = 'Add Products';
  loadContent: boolean = false;
  isLoadingContent = false;
  hideAddButton = false;
  tenantId: string;
  productType: string;
  setFullWindow = false;
  showSideBar = false;
  sideBarSoftwareSearch = "";
  sideBarSubscriptionSearch = "";
  sideBarAzureRiSearch = "";
 

  //Common Variable
  mpnList: string[];
  pendingMessage: string = 'Getting eligible offers';
  defaultMpn: string;
  //Azure Variable
  azureType: string;
  azureReservationType: string;
  azureItemList: DickerSelectListItem[];
  azureReservationItemList: DickerSelectListItem[];
  softwareItemList: DickerSelectListItem[];
  annuityItems: AnnuityItemsViewModel[] = [];
  azurePlanExist: boolean = false;

  //Online Service
  searchSubscriotion: string;
  selectedSubscriptionType: string;
  cspItemList: DickerSelectListItem[];
  subscriptionItems: AnnuityItemsViewModel[] = [];
  subscriptionItemsFilter: AnnuityItemsViewModel[] = [];
  subscriptionItemsPendingList: AnnuityItemsViewModel[] = [];
  stockeCodeArray: string[] = [];
  isAddOn:boolean=false;

  //Azure RI
  azureRiMpnIdSelect: string;
  searchAzureRi: string;
  azureRiUsageSubscriptionList: CSPPerpetual_AzureRISubscriptionViewModel;
  selectedSubscriptionItem: string;
  usageSubscriptionId: string;
  priceList: GetProductPricingV2[];

  locationList: CspAzureLocationModel[];
  selectedLocation: string;

  public paymentFreqList: any[] = [{ "value": 'Upfront' }, { "value": 'Monthly' }];
  public isMonthlyPayment: boolean = false;
  public selectedPaymentFreq: string = 'Upfront';
  public scopeList: any[] = [{ "value": 'Single' }, { "value": 'Shared' }];
  public selectedScope: string = 'Single';
  public selectedSoftSubPaymentFreq: string = 'Upfront';

  azureRiList: CspAzureRilist[] = [];
  azureRiListFilter: CspAzureRilist[] = [];
  azureRIItemsPendingList: CSPPerpetualItemsViewModel[] = [];

  cspReservedInstanceItemsCount: number = 0;
  //Software
  softwareType: string;
  softwareSubscriptionMpnIdSelect: string = "";
  softwareSubscriptionPendingList: CSPPerpetualItemsViewModel[] = [];
  softwareSubscriptionAddItems: CSPPerpetualItemsViewModel[] = [];
  softwareSubscriptionAddItemsFilter: CSPPerpetualItemsViewModel[] = [];


  searchSoftwareSubscription: string;
  checkMpnId: boolean = true;
  isCheck: Boolean;
  softwareMPNControl: FormControl;

  //ngunsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();

  subscriptionType$: Subject<string> = new Subject<string>();

  softwareType$: Subject<string> = new Subject<string>();

  azureRiType$: Subject<string> = new Subject<string>();

  azureRiLocation$: Subject<string> = new Subject<string>();

  azureRiUsageSubscription$: Subject<string> = new Subject<string>();

  azureRiDurationLoading: boolean = false;

  isStaffAccount = false;

  //query params subtype
  at: string;

  ot: string;

  st: string;

  isLoadingListView = true;
  //attestationKeyWord = 'Windows 365 Business';

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private manageService: ManageService,
    private customerService: CustomerService,
    private cs: CommonService,
    private dialog: MatDialog,
    private dialogService: DialogService,
    private authService: AuthService
  ) {

    this.azureItemList = [
      {
        text: 'Reservations',
        value: 'Reservations',
        displayText: 'Reservations',
        selected: false
      },
      {
        text: 'Microsoft Azure',
        value: 'Microsoft Azure',
        displayText: 'Microsoft Azure',
        selected: false
      },
    ];

    this.azureReservationItemList = [];

    this.softwareMPNControl = new FormControl();
  }

  async ngAfterViewInit() {
    await this.cs.waitForElm('#levelOne');
    $('#levelOne').animate({ scrollLeft: $('#managecsp').width() + 505 }, 400);
  }
 
  ngOnInit() {
    this.loadContent = true;

    this.authService.getLoginInfo().pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (user: CurrentUserModel) => {
        this.isStaffAccount = user.isStaffAccount;
        // if(user.hideSOH) {
        //   this.router.navigateByUrl('/home');
        // }
      }
    );
   
    this.manageService.cspReservedInstanceItemsCount$.asObservable().pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value) => {
        this.cspReservedInstanceItemsCount = value;
      }
    );
  
    //reservation type
    const azureReservationTypes$: Observable<{ responseMessage: string, status: boolean, types: string[] }> = this.manageService.getReservationtypes();

    azureReservationTypes$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      const reservationTypes = res?.types?.map((value) => {
        const type = {
          text: value,
          value: value,
          displayText: value,
          selected: false
        };
        return type;
      });
      this.azureReservationItemList = reservationTypes;
    });

    this.manageService.currentExistingCSPSubscriptions.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (items: CSPSubscriptions[]) => {
        if (items) {
          this.stockeCodeArray = items.map((item) => {
            return item.baseSubscription.out_stock_code;
          });

          //filer csp item list
          if (this.subscriptionItems) {
            this.subscriptionItems = this.filterExistingSubscription(this.subscriptionItems);
            this.subscriptionItems.forEach(item => {
              if (this.cs.toNumber(item.itemPrice.replace('$', '').replace(',', '')) === 0) {
                item.disableQty = true;
              }
            });
            this.subscriptionItemsFilter = this.subscriptionItems;
          }


          const azurePlan: CSPSubscriptions = items.find((item) => {
            return item.baseSubscription.out_stock_group === '85CU';
          });
          if (azurePlan && azurePlan.baseSubscription.out_status_desc !== 'Suspended') {
            this.azurePlanExist = true;
          }
        }
      }
    );

    const selectedAzureRiUsageSubscription$ = this.azureRiUsageSubscription$.pipe(
      switchMap((res) => {
        if (this.selectedSubscriptionItem || this.azureType === 'Reservations') {
          this.loadContent = false;

          if (this.cspReservedInstanceItemsCount > 0) {
            this.loadContent = true;
            this.usageSubscriptionId = this.selectedSubscriptionItem;
            return of(this.usageSubscriptionId);

          } else {
            return this.manageService.RegisterSubscription(this.tenantId, this.selectedSubscriptionItem).pipe(
              map((res: ApiResponse) => {
                if (res && !res.status) {
                  this.loadContent = true;
                  this.cs.implementToast(res.responseMessage, "Error");
                  return null;
                } else {
                  this.loadContent = true;
                  this.usageSubscriptionId = this.selectedSubscriptionItem;
                  return this.usageSubscriptionId;
                }
              }),
            )
          }

        } else {
          this.loadContent = true;
          return of(null);
        }
      }),
      catchError((error: any) => {
        this.loadContent = true;
        return of(error);
      })
    );


    combineLatest([this.azureRiType$, this.azureRiLocation$, selectedAzureRiUsageSubscription$])
      .pipe(finalize(() => this.isLoadingContent = false), takeUntil(this.ngUnsubscribe))
      .pipe(switchMap(([azureRiType, azureRiLocation, azureRiUsageSubscription]) => {
          if (azureRiType && azureRiLocation && azureRiUsageSubscription) {
            this.azureRiList = [];
            this.azureRiListFilter = [];
            this.priceList = [];
            return this.manageService.GetCSPAzureRIList_All(this.tenantId, azureRiLocation, this.azureReservationType)
              .pipe(
                switchMap((res: CspAzureRilist[]) => {
                  let ids: number[] = [];
                  res.forEach((v) => {
                    if (!v.description.includes('Year')) {
                      ids.push(v.id);
                    }
                  })

                  return this.manageService.GetCSPAzureRIList_All_Duration(ids).pipe(
                    switchMap((riDuration: AzureRiDuration[]) => {
                      res.forEach((ri) => {
                        riDuration.forEach((duration) => {
                          if (duration.id == ri.id) {
                            ri.description = `${ri.description}, ${duration.year} ${duration.year > 1 ? ' Years' : ' Year'}`
                          }
                        })
                      })
                      return of(res)
                    })
                  )

                }),
              );
          } else {
            this.azureRiList = [];
            this.azureRiListFilter = [];
            this.priceList = [];
            return of(null);
          }
        }))
      .subscribe(res => {
        if (res) {
          this.azureRiList = res;
          this.azureRiList.forEach(item => {
            item.quantity = "1";
            item.minMaxQtyText = "";
            if (item.minQty) {
              item.minMaxQtyText += "Min Order Qty - " + item.minQty + "  ";
            }
            if (item.maxQty) {
              item.minMaxQtyText += "Max Order Qty - " + item.maxQty + "  ";
            }
          });

          this.azureRiList = this.azureRiList.filter(x => x.hasPrice);
          // this.azureRiListFilter = this.azureRiList;
          if (this.searchAzureRi) {
            this.azureRiListFilter = this.azureRiList.filter(cspAzureRiAddItem => cspAzureRiAddItem.title.toLowerCase().includes(this.searchAzureRi.toLowerCase())
              || cspAzureRiAddItem.productId.toLowerCase().includes(this.searchAzureRi.toLowerCase())
              || cspAzureRiAddItem.skuId.toLowerCase().includes(this.searchAzureRi.toLowerCase())
              || (cspAzureRiAddItem.productId.toLowerCase() + ":" + cspAzureRiAddItem.skuId.toLowerCase()).includes(this.searchAzureRi.toLowerCase()));
          } else {
            this.azureRiListFilter = this.azureRiList;
          }
          this.selectPaymentFrequency();
        }
      });

    //init azureType
    this.activatedRoute.queryParamMap.pipe(
      take(1)
    ).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (queryParams) => {
        if (queryParams.has('at') && queryParams.get('at') !== 'Microsoft Azure') {
          this.azureType = 'Reservations';
        }
      }
    );

    const productType$ = this.activatedRoute.paramMap.pipe(
      tap((params) => { this.productType = params.get('productType'); }),
      switchMap((params) => {
        return this.activatedRoute.queryParamMap.pipe(
          switchMap((queryParams) => {
            switch (params.get('productType')) {
              case 'Software':
                if (!this.cspItemList || !this.softwareItemList) {
                  return this.manageService.GetCSPItemListView(this.tenantId).pipe(
                    switchMap((result) => {
                      this.cspItemList = result.subscriptionTypes.filter(item => item.value !== '85CU');
                      this.manageService.subscriptionTypes = result.subscriptionTypes;
                      this.isLoadingListView = false;
                      this.softwareItemList = result.perpetualTypes.slice();

                      this.router.navigate(['./'], { relativeTo: this.activatedRoute, queryParams: { st: this.softwareItemList.find(m => m.selected).value, ot: this.cspItemList.find(m => m.selected).value }, queryParamsHandling: 'merge' });
                      return of(null);

                    })
                  );
                } else {
                  if (queryParams.has('st')) {

                    if (this.st == queryParams.get('st')) {
                      return of(null);
                    } else {

                      this.isLoadingContent = true;
                      this.st = this.softwareType = queryParams.get('st');
                      return this.manageService.GetCSPPerpetualItemList(queryParams.get('st')).pipe(
                        finalize(() => {
                          this.isLoadingContent = false;
                          this.loadContent = true;
                        }),
                        map((data) => {
                          return {
                            productType: params.get('productType'),
                            productSubType: queryParams.get('st'),
                            data: data
                          };
                        })
                      );
                    }

                  } else {
                    this.router.navigate(['./'], { relativeTo: this.activatedRoute, queryParams: { st: null }, queryParamsHandling: 'merge' });
                    return of(null);
                  }
                }
              case 'OnlineService':
                if (!this.cspItemList || !this.softwareItemList) {
                  return this.manageService.GetCSPItemListView(this.tenantId)
                    .pipe(
                      switchMap((result) => {
                        this.cspItemList = result.subscriptionTypes.filter(item => item.value !== '85CU');
                        this.softwareItemList = result.perpetualTypes.slice();
                        this.manageService.subscriptionTypes = result.subscriptionTypes;
                        this.isLoadingListView = false;

                        this.router.navigate(['./'], {
                          relativeTo: this.activatedRoute,
                            queryParams: {
                              st: this.softwareItemList.find(m => m.selected).value,
                              ot: this.cspItemList.find(m => m.selected).value,
                              reload: Date.now()
                            },
                            queryParamsHandling: 'merge'
                        });

                        return of(null);
                      })
                    );
                } else {
                  if (queryParams.has('ot')) {

                    if (this.ot === queryParams.get('ot')) {
                      return of(null);
                    } else {
                      this.ot = this.selectedSubscriptionType = queryParams.get('ot');
                      this.isLoadingContent = true;
                      this.loadContent = false;
                      return this.manageService.GetCSPtems(this.tenantId, queryParams.get('ot'))
                      .pipe(
                        finalize(() => {
                          this.isLoadingContent = false;
                          this.loadContent = true;
                        }),
                        map((data) => {
                          return {
                            productType: params.get('productType'),
                            productSubType: queryParams.get('ot'),
                            data: data
                          };
                        })
                      );
                    }
                  } else {
                    this.router.navigate(['./'], { relativeTo: this.activatedRoute, queryParams: { ot: null }, queryParamsHandling: 'merge' });
                    return of(null);
                  }
                }
              case 'Azure':
                if (queryParams.has('at') && queryParams.get('at') === 'Microsoft Azure') {
                  if (this.at === queryParams.get('at')) {
                    return of(null);
                  } else {
                    this.at = this.azureType = queryParams.get('at');
                    this.isLoadingContent = true;
                    return this.manageService.GetCSPtems(this.tenantId, '85CU')
                    .pipe(
                      finalize(() => {
                        this.isLoadingContent = false;
                        this.loadContent = true;
                      }),
                      map((data) => {
                        return {
                          productType: params.get('productType'),
                          productSubType: queryParams.get('at'),
                          data: data
                        };
                      })
                    );
                  }
                } else {

                  return of({
                    productType: params.get('productType'),
                    productSubType: null,
                    data: []
                  });
                }
              case 'MicrosoftAzure':
                this.changeAzureType('Microsoft Azure');
                return of(null); 
                
              case 'Reservations':

                this.azureType = params.get('productType');

                if (queryParams.has('at') && queryParams.get('at') !== 'Microsoft Azure') {

                  if (this.at !== queryParams.get('at')) {
                    this.at = this.azureReservationType = queryParams.get('at');
                    this.azureRiType$.next(this.azureReservationType);
                  }

                }
                return of(null);

              default:
                return of(null);
            }
          }));
      })
    );


    this.activatedRoute.parent.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(params => {

      this.tenantId = params.get('tenantId');

      this.manageService.GetDefaultMPN().pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: string[]) => {
        this.mpnList = res;
        if (this.mpnList && this.mpnList.length) {
          this.defaultMpn = this.mpnList[0];
        }
      },
        (error: any) => {
          console.info(error);
        });

      this.manageService.GetCSPAzureRIItemList(this.tenantId).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: CSPPerpetual_AzureRISubscriptionViewModel) => {
        this.azureRiUsageSubscriptionList = res;
      },
        (error: any) => {
          console.info(error);
        });

      this.manageService.GetAzureLocationList().pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: CspAzureLocationModel[]) => {
        this.locationList = res;
        if (this.locationList.length) {
          this.selectedLocation = this.locationList[0].locationName;
          this.azureRiLocation$.next(this.selectedLocation);
        }
      },
        (error: any) => {
          console.info(error);
        });


      productType$
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: (res: { productType: string, productSubType: string, data: any } | null) => {
            if (res) {
  
              switch (res.productType) {
                case 'Software':
  
                  this.softwareSubscriptionAddItems = [];
  
                  this.softwareSubscriptionAddItemsFilter = [];
  
                  this.softwareSubscriptionAddItems = res.data;
  
                  this.softwareSubscriptionAddItems.forEach(item => {
                    item.quantity = '1';
                    item.minMaxQtyText = '';
                    if (item.minQty) {
                      item.minMaxQtyText += 'Min Order Qty - ' + item.minQty + ' ';
                    }
                    if (item.maxQty) {
                      item.minMaxQtyText += 'Max Order Qty - ' + item.maxQty + ' ';
                    }
                  });
                  this.proccessSoftwareSubsList();
                  break;
                case 'OnlineService':
                  this.subscriptionItems = [];
                  this.subscriptionItems = this.filterExistingSubscription(res.data);
                  this.manageService.setCurrentCSPProductList(this.subscriptionItems)
                  this.subscriptionItems.forEach(item => {
                    if (this.cs.toNumber(item.itemPrice.replace('$', '').replace(',', '')) === 0) {
                      item.disableQty = true;
                    }
                  });
                  if (this.searchSubscriotion) {
                    this.subscriptionItemsFilter = this.subscriptionItems.filter(annuityItem => annuityItem.description.toLowerCase().includes(this.searchSubscriotion.toLowerCase()) || annuityItem.stockCode.toLowerCase().includes(this.searchSubscriotion.toLowerCase()));
  
                  } else {
                    this.subscriptionItemsFilter = this.subscriptionItems;
                  }
                  break;
                case 'Azure':
                  this.annuityItems = [];
                  if (res.data) {
                    this.annuityItems = res.data;
                    this.annuityItems.forEach(item => {
                      if (this.cs.toNumber(item.itemPrice.replace('$', '').replace(',', '')) === 0) {
                        item.disableQty = true;
                      }
                    });
                  }
                  break;
              }
            }
          },
          error: (err: string) => this.cs.implementToast(err, "Error")
        });
    });


    //clear pending lists
    this.manageService.monitorPendingAzureRi([]);
    this.manageService.monitorPendingSubscriptions([]);
    this.manageService.monitorPendingSoftware([]);

    //load pendinglist
    this.manageService.currentPendingAzureRi.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: CSPPerpetualItemsViewModel[]) => {
      this.azureRIItemsPendingList = res;
    },
      (error: any) => {
        console.info(error);
      });

    this.manageService.currentPendingSoftware.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: CSPPerpetualItemsViewModel[]) => {
      this.softwareSubscriptionPendingList = res;
    },
      (error: any) => {
        console.info(error);
      });

    this.manageService.currentPendingSubscriptions.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: AnnuityItemsViewModel[]) => {
      this.subscriptionItemsPendingList = res;
    },
      (error: any) => {
        console.error(error);
      });

    //confirmMPN
    this.softwareMPNControl.valueChanges.pipe(
      debounceTime(1000)
    ).pipe(takeUntil(this.ngUnsubscribe)).subscribe(mpn => {
      this.confirmMpnID(mpn);
    });
    
  }
  onLoading(currentLoadingStatus: boolean) {
    this.isLoadingContent = !currentLoadingStatus;
  }

  public proccessSoftwareSubsList(): void {
    if (this.selectedSoftSubPaymentFreq == 'Upfront') {
      if (this.searchSoftwareSubscription) {

        this.softwareSubscriptionAddItemsFilter = this.softwareSubscriptionAddItems.filter(softwareSubscription => softwareSubscription.title.toLowerCase().includes(this.searchSoftwareSubscription.toLowerCase()) || softwareSubscription.stockCode.toLowerCase().includes(this.searchSoftwareSubscription.toLowerCase()));

      } else {

        this.softwareSubscriptionAddItemsFilter = this.softwareSubscriptionAddItems;
      }
    } else if (this.selectedSoftSubPaymentFreq == 'Monthly') {
      this.manageService.GetMonthlyBillingEligibleCSPStockcodes().subscribe((res: string[]) => {
        const softwareSubscriptionAddItemsForMonthly = this.softwareSubscriptionAddItems.filter(s => (res.includes(s.stockCode) && s.description.includes('YEAR')))
        if (this.searchSoftwareSubscription) {
          this.softwareSubscriptionAddItemsFilter = softwareSubscriptionAddItemsForMonthly.filter(softwareSubscription => softwareSubscription.title.toLowerCase().includes(this.searchSoftwareSubscription.toLowerCase()) || softwareSubscription.stockCode.toLowerCase().includes(this.searchSoftwareSubscription.toLowerCase()));
        } else {
          this.softwareSubscriptionAddItemsFilter = softwareSubscriptionAddItemsForMonthly;
        }
        this.softwareSubscriptionAddItemsFilter.forEach(s => {
          const year = s.description[s.description.indexOf('YEAR')-2]
          s.monthlyPrice = (Number(s.itemPrice.replace(/[^0-9.-]+/g,"")) / (12 * parseInt(year))).toFixed(2);
        });
        this.isLoadingContent = false;
      },
        (error: any) => {
          console.log(error);
          this.isLoadingContent = false;
        }); 
    }
  }


  //Azure Methods

  changeProductType(type: string): void {

    if (!this.isLoadingContent) {
      this.showSideBar = false;

      if (type == 'Azure') {
        if (!this.azureType) {
          type = 'Azure';
        } else {
          if (this.azureType == 'Reservations') {
            type = 'Reservations';
          } else if (this.azureType == 'Microsoft Azure') {
            type = 'Azure';
          }
        }
      }
      this.cs.applyScrollFixedHeader(this.parentWrapper);
      this.router.navigate([`../${type}`,], { relativeTo: this.activatedRoute, queryParamsHandling: 'preserve' });
    }

  }

  changeAzureType(event: any): void {

    if (event == 'Microsoft Azure') {
      this.router.navigate(['../', 'Azure'], {
        relativeTo: this.activatedRoute, queryParamsHandling: 'merge', queryParams: {
          at: event
        }
      });

    } else if (event == 'Reservations') {
      this.router.navigate(['../', 'Reservations'], {
        relativeTo: this.activatedRoute, queryParamsHandling: 'merge', queryParams: {
          at: null
        }
      });
    } else {
      this.at = this.azureReservationType = '';
      this.azureRiType$.next(this.azureReservationType);
      this.router.navigate(['../', 'Azure'], {
        relativeTo: this.activatedRoute, queryParamsHandling: 'merge', queryParams: {
          at: null
        }
      });
    }
  }

  addAnnuityItem(annuityItem: AnnuityItemsViewModel): void {

    //subscription not existing in pendinglist
    annuityItem.totalPrice = this.cs.toNumber(annuityItem.itemPrice.replace('$', '').replace(',', '')) * this.cs.toNumber(annuityItem.quantity);
    annuityItem.editMPN = true;
    annuityItem.mpn = this.defaultMpn;
    this.subscriptionItemsPendingList.push(new AnnuityItemsViewModel(annuityItem));

    this.manageService.monitorMPNIDCheckStatus(false);

    //navigate to product confirm screen
    this.cs.implementToast("Item added successfully", "Success");
    this.manageService.monitorPendingSubscriptions(this.subscriptionItemsPendingList);
    this.showSideBarByType();
  }

  finishAddSubscriotions(): void {
    this.router.navigate(['../'], { queryParamsHandling: 'preserve', relativeTo: this.activatedRoute })
    $('#levelOne').animate({ scrollLeft: 250 }, 400);
    // this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/CSP/CSPDetailsNew/' + this.tenantId);
  }

  isHiddenAddButton(): boolean {
    let isHidden: boolean;
    if (this.subscriptionItemsPendingList.find(item => item.stockGroup === '85CU')) {
      isHidden = true;
    } else {
      isHidden = false;
    }
    return isHidden;
  }


  //AzureRI  Methods

  selectUsageSubscription(): void {

    this.azureRiUsageSubscription$.next(this.selectedSubscriptionItem);

  }

  selectLocation(): void {
    this.azureRiLocation$.next(this.selectedLocation);
  }

  selectPaymentFrequency(): void {
    this.isMonthlyPayment = this.selectedPaymentFreq === 'Monthly';
    if (this.isMonthlyPayment) {
      //get id list
      this.azureRiDurationLoading = true;
      const azureRiIdList = this.azureRiListFilter.map(m => m.id);
      this.manageService.GetCSPAzureRIList_All_Duration(azureRiIdList).subscribe((res: AzureRiDuration[]) => {
        this.azureRiListFilter.forEach(ri => {
          res.forEach(riDuration => {
            if (riDuration.id === ri.id) {
              ri.monthlyPrice = (parseFloat(ri.itemPrice) / (12 * riDuration.year)).toFixed(2);
            }
          });
        });
        this.azureRiDurationLoading = false;
      },
        (error: any) => {
          console.log(error);
          this.azureRiDurationLoading = false;
        });
    }
  }

  changeAzureReservationType(event: any): void {

    this.router.navigate(['../', 'Reservations'], {
      relativeTo: this.activatedRoute,
      queryParamsHandling: 'merge',
      queryParams: { at: event }
    });
  }

  getCspAzureRiList(): void {

    if (this.usageSubscriptionId && this.selectedLocation && this.azureReservationType) {

      this.azureRiList = [];
      this.azureRiListFilter = [];
      this.priceList = [];

      this.isLoadingContent = true;

      this.manageService.GetCSPAzureRIList_All(this.tenantId, this.selectedLocation, this.azureReservationType).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: CspAzureRilist[]) => {

        this.azureRiList = res;

        this.azureRiList.forEach(item => {
          item.quantity = "1";
          item.minMaxQtyText = "";
          if (item.minQty) {
            item.minMaxQtyText += "Min Order Qty - " + item.minQty + "  ";
          }
          if (item.maxQty) {
            item.minMaxQtyText += "Max Order Qty - " + item.maxQty + "  ";
          }
        });

        let skuList = this.azureRiList.map(x => x.productId + ':' + x.skuId);

        this.manageService.GetProductPricingList(skuList).pipe(takeUntil(this.ngUnsubscribe)).subscribe((priceList: GetProductPricingV2[]) => {
          if (priceList && priceList.length) {
            this.priceList = priceList;

            this.azureRiList.forEach(item => {
              this.priceList.forEach(price => {
                if (price.out_stock_code == item.productId + ":" + item.skuId) {
                  item.itemPrice = price.out_current_price;
                  item.billingFrequency = price.out_billing_freq;
                }
              });
              if (!item.itemPrice) {
                item.hasPrice = false;
              } else {
                item.hasPrice = true;
              }
            });
          }
          this.azureRiList = this.azureRiList.filter(x => x.hasPrice);
          // this.azureRiListFilter = this.azureRiList;
          if (this.searchAzureRi) {

            this.azureRiListFilter = this.azureRiList.filter(cspAzureRiAddItem => cspAzureRiAddItem.title.toLowerCase().includes(this.searchAzureRi.toLowerCase())
              || cspAzureRiAddItem.productId.toLowerCase().includes(this.searchAzureRi.toLowerCase())
              || cspAzureRiAddItem.skuId.toLowerCase().includes(this.searchAzureRi.toLowerCase())
              || (cspAzureRiAddItem.productId.toLowerCase() + ":" + cspAzureRiAddItem.skuId.toLowerCase()).includes(this.searchAzureRi.toLowerCase()));

          } else {

            this.azureRiListFilter = this.azureRiList;

          }

          //this.calculateMontlyPayment();
          console.log(44444)
          this.isLoadingContent = false;
        },
          (error: any) => {
            console.info(error);
            console.log(55555)
            this.isLoadingContent = false;
          });

      },
        (error: any) => {
          console.info(error);
          console.log(66666)
          this.isLoadingContent = false;
        });

    } else {

      this.azureRiList = [];

      this.azureRiListFilter = [];

      this.priceList = [];
    }
  }

  calculateMontlyPayment(): void {

    this.azureRiListFilter.map(item => {
      if (item.title.includes('1 Year')) {
        item.monthlyPrice = (parseFloat(item.itemPrice) / 12).toFixed(2);
      } else if (item.title.includes('3 Years')) {
        item.monthlyPrice = (parseFloat(item.itemPrice) / 36).toFixed(2);
      }
    });
  }

  disableLocationandPaymentFrenq(): boolean {

    if (this.selectedSubscriptionItem) {

      return false;

    } else {

      return true;

    }

  }

  filterAzureRiItems(): void {
    this.azureRiListFilter = this.azureRiList.filter(cspAzureRiAddItem => cspAzureRiAddItem.title.toLowerCase().includes(this.searchAzureRi.toLowerCase())
      || cspAzureRiAddItem.productId.toLowerCase().includes(this.searchAzureRi.toLowerCase())
      || cspAzureRiAddItem.skuId.toLowerCase().includes(this.searchAzureRi.toLowerCase())
      || (cspAzureRiAddItem.productId.toLowerCase() + ":" + cspAzureRiAddItem.skuId.toLowerCase()).includes(this.searchAzureRi.toLowerCase()));
  }

  addAzureRiItem(software: CspAzureRilist) {
    if (this.usageSubscriptionId) {

      this.loadContent = false;
      this.manageService.GetInventoryCheckForAzureRI(this.tenantId, this.usageSubscriptionId, software.productId, software.skuId, this.locationList.filter(x => x.locationName == this.selectedLocation)[0].armRegionName).pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: ApiResponse) => {
        if (response && response.status) {
          //if (!this.azureRIItemsPendingList.filter(item => item.productId + item.skuId == software.productId + software.skuId).length) {

          let cSPPerpetualItem = {} as CSPPerpetualItemsViewModel;
          cSPPerpetualItem.maxQty = software.maxQty.toString();
          cSPPerpetualItem.minQty = software.minQty.toString();
          cSPPerpetualItem.productId = software.productId;
          cSPPerpetualItem.description = software.description;
          cSPPerpetualItem.skuId = software.skuId;
          // cSPPerpetualItem.title = software.title;
          cSPPerpetualItem.title = software.description;
          cSPPerpetualItem.stockCode = software.productId + ":" + software.skuId;
          cSPPerpetualItem.programType = "CSP";
          cSPPerpetualItem.quantity = software.quantity;
          cSPPerpetualItem.itemPrice = software.itemPrice.replace('$', '').replace(',', '');
          cSPPerpetualItem.billingFrequency = software.billingFrequency;
          cSPPerpetualItem.catalogItemId = software.catalogId.toString();
          if (this.isMonthlyPayment) {
            cSPPerpetualItem.totalPrice = this.cs.toNumber(software.monthlyPrice.replace('$', '').replace(',', '')) * this.cs.toNumber(software.quantity);
          } else {
            cSPPerpetualItem.totalPrice = this.cs.toNumber(software.itemPrice.replace('$', '').replace(',', '')) * this.cs.toNumber(software.quantity);
          }
          cSPPerpetualItem.mpnId = this.azureRiMpnIdSelect;
          cSPPerpetualItem.lineType = "RESER";
          cSPPerpetualItem.subscriptionId = this.usageSubscriptionId;
          cSPPerpetualItem.isMonthly = this.isMonthlyPayment;
          cSPPerpetualItem.monthlyPrice = software.monthlyPrice;
          cSPPerpetualItem.scope = this.selectedScope;
          this.azureRIItemsPendingList.push(cSPPerpetualItem);
          this.loadContent = true;
          this.cs.implementToast("Item added successfully", "Success");
          //navigate to product confirm screen
          this.manageService.monitorPendingAzureRi(this.azureRIItemsPendingList);
          this.showSideBarByType();
        } else {
          // this.commonService.showError("#" + software.productId + "_" + software.skuId, "This item is not available", "right");
          this.cs.implementToast("This item is not available", "Error");
          this.loadContent = true;
        }
      },
        (error: any) => {
          console.info(error);
          this.loadContent = true;
        });

    } else {
      this.cs.implementToast("Please select a usage subscription", "Error");
    }
  }

  removeAzureRIItemsPending(index: number): void {
    this.azureRIItemsPendingList.splice(index, 1);
    this.manageService.monitorPendingAzureRi(this.azureRIItemsPendingList);
  }

  finishAddAzureRi() {
    //push pendinglist
    if (!this.usageSubscriptionId) {
      // this.commonService.showError(".usagesub", "Please select a usage subscription", "right");
      this.cs.implementToast('Please select a usage subscription', 'Error');
    } else {
      this.manageService.monitorPendingAzureRi(this.azureRIItemsPendingList);
      // this.manageService.monitorSelectedTabIndex(3);
      this.router.navigate(['../'], { queryParamsHandling: 'preserve', relativeTo: this.activatedRoute })
      $('#levelOne').animate({ scrollLeft: 250 }, 400);
      // this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/CSP/CSPDetailsNew/' + this.tenantId);
    }
  }


  //Online Service Methods

  filterSubscriptionItems(): void {          
      this.subscriptionItemsFilter = this.subscriptionItems.filter
      (annuityItem => annuityItem.description.toLowerCase().includes(this.searchSubscriotion.toLowerCase()) || annuityItem.stockCode.toLowerCase().includes(this.searchSubscriotion.toLowerCase()));    
    
  }

  changeQty(annuityItem: AnnuityItemsViewModel): void {

    if (!annuityItem.quantity) {
      annuityItem.quantity = '1';
    } else {
      if (annuityItem.minQty) {
        if (this.cs.toInteger(annuityItem.quantity) < this.cs.toInteger(annuityItem.minQty.replace(',', ''))) {
          this.cs.implementToast(`the min qty is ${annuityItem.minQty}`, "Info");
          annuityItem.quantity = this.cs.toInteger(annuityItem.minQty.replace(',', '')).toString();
        }
      }
      if (annuityItem.maxQty) {
        if (this.cs.toInteger(annuityItem.quantity) > this.cs.toInteger(annuityItem.maxQty.replace(',', ''))) {
          this.cs.implementToast(`the max qty is ${annuityItem.maxQty}`, "Info");
          annuityItem.quantity = this.cs.toInteger(annuityItem.maxQty.replace(',', '')).toString();
        }
      }
    }
  }

  addSubscriptionItem(annuityItem: AnnuityItemsViewModel): void {
    const qualification = this.cspItemList?.find(i => i.value == this.selectedSubscriptionType)?.text?.split(' - ')[1]
    if (annuityItem.attestationRequired) {
      const dialogRef = this.dialog.open(CSPConditionCheckComponent, {
        width: '650px',
      });

      dialogRef.afterClosed().subscribe((res) => {
        if (res) {
          //subscription not existing in pendinglist
          annuityItem.totalPrice = this.cs.toNumber(annuityItem.itemPrice.replace('$', '').replace(',', '')) * this.cs.toNumber(annuityItem.quantity);
          annuityItem.editMPN = true;
          annuityItem.mpn = this.defaultMpn;
          annuityItem.qualification = qualification;
          this.subscriptionItemsPendingList.push(new AnnuityItemsViewModel(annuityItem));

          this.manageService.monitorMPNIDCheckStatus(false);
          this.cs.implementToast("Item added successfully", "Success");
          //navigate to product confirm screen
          this.manageService.monitorPendingSubscriptions(this.subscriptionItemsPendingList);
          this.showSideBarByType();
        }
      })
    } else {
      //subscription not existing in pendinglist
      annuityItem.totalPrice = this.cs.toNumber(annuityItem.itemPrice.replace('$', '').replace(',', '')) * this.cs.toNumber(annuityItem.quantity);
      annuityItem.editMPN = true;
      annuityItem.mpn = this.defaultMpn;
      annuityItem.qualification = qualification;
      this.subscriptionItemsPendingList.push(new AnnuityItemsViewModel(annuityItem));

      this.manageService.monitorMPNIDCheckStatus(false);
      this.cs.implementToast("Item added successfully", "Success");
      //navigate to product confirm screen
      this.manageService.monitorPendingSubscriptions(this.subscriptionItemsPendingList);
      this.showSideBarByType();
    }
  }

  removeSubscriptionPendingItem(index: number): void {
    this.subscriptionItemsPendingList.splice(index, 1);
    this.manageService.monitorPendingSubscriptions(this.subscriptionItemsPendingList);
  }

  changeSubscriptionType(event: any): void {
    this.router.navigate(['./'], { queryParams: { ot: event }, relativeTo: this.activatedRoute, queryParamsHandling: 'merge' });
  }

  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  toHTML(input: any): any {
    return new DOMParser().parseFromString(input, 'text/html').documentElement.innerHTML;
  }

  filterExistingSubscription(res: AnnuityItemsViewModel[]): AnnuityItemsViewModel[] {
    return res;
  }

  //Software Methods
  changeSoftwareType(event: any): void {
    this.router.navigate(['./'], { queryParams: { st: event }, relativeTo: this.activatedRoute, queryParamsHandling: 'merge' });
  }

  filterSoftwareSubscriptionItems(): void {
    this.softwareSubscriptionAddItemsFilter = this.softwareSubscriptionAddItems.filter(softwareSubscription => softwareSubscription.title.toLowerCase().includes(this.searchSoftwareSubscription.toLowerCase()) || softwareSubscription.stockCode.toLowerCase().includes(this.searchSoftwareSubscription.toLowerCase()));
  }

  
  confirmMpnID(mpnId: string): void {

    if (mpnId === '' || mpnId === null) {
      this.checkMpnId = true;
    } else {
      this.cs.implementToast('Verifying MPN ID ...', 'Info');
      this.isCheck = true;
      this.manageService.GetPartnerByMPNId(mpnId).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: MnpIdAipiResponse) => {
        if (res.result === 'Success') {
          this.manageService.GetMPAStatusByMPNId(mpnId).pipe(takeUntil(this.ngUnsubscribe)).subscribe((result: MnpIdAipiResponse) => {
            if (result.status === false) {
              this.checkMpnId = result.status;
              this.cs.implementToast('Verifying Microsoft Partner Agreement Status ...', 'Info');
              const dialogRef = this.dialog.open(ConfirmMnpidComponent, {
                width: '650px',
                panelClass: 'mat-dialog-wrapper'
              });
              this.isCheck = false;
            } else {
              this.checkMpnId = result.status;
              this.isCheck = false;
            }
          });
        } else {
          this.cs.implementToast(res.info, 'Error');
          this.isCheck = false;
          this.checkMpnId = false;
        }
      },
        (error: any) => {
          console.info(error);
          this.loadContent = true;
        }
      );
    }
  }

  showAutoCompletePanel(trigger: any): void {
    trigger.openPanel();
  }

  addSoftwareSubscription(software: CSPPerpetualItemsViewModel) {
    const qualification = this.softwareItemList?.find(i => i.value == this.softwareType)?.text?.split(' - ')[1]
    software.isMonthly = this.selectedSoftSubPaymentFreq == 'Monthly' ? true : false;

    software.totalPrice = software.isMonthly ? this.cs.toNumber(software.monthlyPrice) * this.cs.toNumber(software.quantity):
      this.cs.toNumber(software.itemPrice.replace('$', '').replace(',', '')) * this.cs.toNumber(software.quantity);
    software.mpnId = this.softwareSubscriptionMpnIdSelect;
    software.qualification = qualification;
    this.softwareSubscriptionPendingList.push({ ...software });

    //navigate to product confirm screen
    this.cs.implementToast("Item added successfully", "Success");
    this.manageService.monitorPendingSoftware(this.softwareSubscriptionPendingList);
    this.showSideBarByType();
   
  }

  removeSoftwareSubscriptionPendingList(index: number): void {
    const temp = [ ...this.softwareSubscriptionPendingList ]
    temp.splice(index, 1);
    this.manageService.monitorPendingSoftware(temp);
  }

  finishAddSoftware(): void {
    //push pendinglist
    this.manageService.monitorPendingSoftware(this.softwareSubscriptionPendingList);
    this.manageService.monitorSelectedTabIndex(4);

    this.router.navigate(['../'], { queryParamsHandling: 'preserve', relativeTo: this.activatedRoute })
    $('#levelOne').animate({ scrollLeft: 250 }, 400);
    // this.router.navigateByUrl("/manageSubscriptions/manageAnnuities/CSP/CSPDetailsNew/" + this.tenantId);
  }

  showSideBarByType() {
    if (!this.showSideBar) {
      this.showSideBar = true;
      //$('#levelOne').animate({ scrollLeft: $('#managecsp').width() + $('#addProduct').width() + 505 }, 400);

    }
  }

  close() {
    if ((this.subscriptionItemsPendingList.length > 0) || (this.azureRIItemsPendingList.length > 0) || (this.softwareSubscriptionPendingList.length > 0)) {
      this.dialogService.confirm("Leave Site? Changes that you made may not be saved.")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((canLeave: boolean) => {
          if (canLeave) {
            this.manageService.monitorPendingAzureRi([]);
            this.manageService.monitorPendingSubscriptions([]);
            this.manageService.monitorPendingSoftware([]);
            if (this.cs.isInCustiomerMenu()) {
              this.customerService.currentCustomerWatch.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: DDCustomer) => { 
                this.router.navigateByUrl("/customers/" + res?.id  + "/CSP/" + this.tenantId);
              });
            } else {
              this.router.navigateByUrl("/manageSubscriptions/manageAnnuities/CSP/CSPDetailsNew/" + this.tenantId);
            }
          }
        });

    } else {
      if (this.cs.isInCustiomerMenu()) {
        this.customerService.currentCustomerWatch.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: DDCustomer) => { 
          this.router.navigateByUrl("/customers/" + res?.id  + "/CSP/" + this.tenantId);
        });
      } else {
        this.router.navigateByUrl("/manageSubscriptions/manageAnnuities/CSP/CSPDetailsNew/" + this.tenantId);
      }
    }
  }

  closeSideBar() {
    $('#levelOne').animate({ scrollLeft: $('#managecsp').width() + 505 }, 400);
    this.showSideBar = false;
  }

  confirmProduct() {
    // if (this.isStaffAccount) {
      this.router.navigate(['ConfirmProductsV2'], { queryParamsHandling: 'preserve', relativeTo: this.activatedRoute });
    // } else {
    //   this.router.navigate(['ConfirmProducts'], { queryParamsHandling: 'preserve', relativeTo: this.activatedRoute });
    // }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  
  showAddOn(event:any):void  {     
    if (!event.checked) {      
     this.isAddOn=event.checked;
    } else {
      this.isAddOn=event.checked; 
    } 
  }
}
